function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Sort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 24.5189c0-1.4907 1.6155-2.4535 2.9204-1.7081l4.5204 2.5156c.3417.1863.7611.1863 1.0874 0l4.5359-2.5156a1.9733 1.9733 0 0 1 2.5543.7914 1.9718 1.9718 0 0 1-.5815 2.6093l-6.4621 3.9132a1.1343 1.1343 0 0 1-1.1651 0l-6.4621-3.9132A1.972 1.972 0 0 1 9 24.5189ZM25 9.7668c0 1.4907-1.6311 2.4535-2.9515 1.7081l-4.5048-2.5156a1.1343 1.1343 0 0 0-1.0874 0l-4.5514 2.5156a1.9733 1.9733 0 0 1-2.4786-.8401 1.9715 1.9715 0 0 1 .5368-2.5606l6.4466-3.9132a1.1343 1.1343 0 0 1 1.1651 0l6.4621 3.9132c.5903.3572.9631.9938.9631 1.6926ZM22.4369 14.2857H11.5631C10.1475 14.2857 9 15.5649 9 17.1429 9 18.7208 10.1475 20 11.5631 20h10.8738C23.8525 20 25 18.7208 25 17.1429c0-1.578-1.1475-2.8572-2.5631-2.8572Z",
    fill: "#BFF6F8",
    stroke: "#528693",
    strokeWidth: ".8"
  }));
}

export default Sort;